/* ==========================================================================
   APERÇU EN DIRECT : Atelier de Soan
   Affiche la personnalisation du client sur l'image du produit pendant
   qu'il remplit les champs. Réglages par produit : snippets/soan-apercu.liquid
   ========================================================================== */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  var SIGNES = [ // [jour de début, mois] -> signe (code du symbole)
    [20, 1, 9810], [19, 2, 9811], [21, 3, 9800], [20, 4, 9801], [21, 5, 9802], [21, 6, 9803],
    [23, 7, 9804], [23, 8, 9805], [23, 9, 9806], [23, 10, 9807], [22, 11, 9808], [22, 12, 9809]
  ];
  // Verseau(♒) 20/01, Poissons(♓) 19/02, Bélier(♈) 21/03, Taureau(♉) 20/04, Gémeaux(♊) 21/05,
  // Cancer(♋) 21/06, Lion(♌) 23/07, Vierge(♍) 23/08, Balance(♎) 23/09, Scorpion(♏) 23/10,
  // Sagittaire(♐) 22/11, Capricorne(♑) 22/12

  function signe(dateTxt) {
    var m = String(dateTxt || '').match(/([0-9]{1,2})[^0-9]+([0-9]{1,2})/);
    if (!m) return null;
    var j = parseInt(m[1], 10), mo = parseInt(m[2], 10);
    if (!(j >= 1 && j <= 31 && mo >= 1 && mo <= 12)) return null;
    var code = 9809; // Capricorne par défaut (du 22/12 au 19/01)
    for (var i = 0; i < SIGNES.length; i++) {
      var s = SIGNES[i];
      if (mo > s[1] || (mo === s[1] && j >= s[0])) code = s[2];
    }
    return String.fromCharCode(code) + String.fromCharCode(65038); // variante texte (pas emoji)
  }

  function el(name, attrs, parent) {
    var e = document.createElementNS(NS, name);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  }
  function star(cx, cy, r) { // petite étoile à 4 branches
    var i = r * 0.22;
    return 'M' + cx + ',' + (cy - r) + ' Q' + (cx + i) + ',' + (cy - i) + ' ' + (cx + r) + ',' + cy +
      ' Q' + (cx + i) + ',' + (cy + i) + ' ' + cx + ',' + (cy + r) +
      ' Q' + (cx - i) + ',' + (cy + i) + ' ' + (cx - r) + ',' + cy +
      ' Q' + (cx - i) + ',' + (cy - i) + ' ' + cx + ',' + (cy - r) + 'Z';
  }

  function heart(cx, cy, s) { // cœur dessiné au trait, centré sur (cx, cy), hauteur s
    var w = s * 0.55, t = cy - s * 0.32, b = cy + s * 0.5;
    return 'M' + cx + ',' + b +
      ' C' + (cx - w * 0.9) + ',' + (cy + s * 0.05) + ' ' + (cx - w * 1.05) + ',' + (t - s * 0.1) + ' ' + (cx - w * 0.5) + ',' + (t - s * 0.16) +
      ' C' + (cx - w * 0.15) + ',' + (t - s * 0.2) + ' ' + cx + ',' + (t - s * 0.02) + ' ' + cx + ',' + t +
      ' C' + cx + ',' + (t - s * 0.02) + ' ' + (cx + w * 0.15) + ',' + (t - s * 0.2) + ' ' + (cx + w * 0.5) + ',' + (t - s * 0.16) +
      ' C' + (cx + w * 1.05) + ',' + (t - s * 0.1) + ' ' + (cx + w * 0.9) + ',' + (cy + s * 0.05) + ' ' + cx + ',' + b + 'Z';
  }

  function build(box, cfg) {
    var form = box.closest('form') || document;
    var scope = box.closest('product-info') || document;
    var vb = cfg.view ? cfg.view.join(' ') : '0 0 ' + cfg.w + ' ' + cfg.h;
    var svg = el('svg', { viewBox: vb, role: 'img', 'aria-label': 'Aperçu de votre personnalisation', 'class': 'soan-apercu__svg' });
    var ib = cfg.imgBox || [0, 0, cfg.w, cfg.h];
    el('image', { href: cfg.img, x: ib[0], y: ib[1], width: ib[2], height: ib[3], preserveAspectRatio: 'xMidYMid slice' }, svg);
    var g = el('g', { 'class': 'soan-apercu__grav' }, svg);
    box.querySelector('.soan-apercu__frame').appendChild(svg);

    // Décors fixes (ex. cœurs gravés)
    cfg.items.filter(function (it) { return it.type === 'heart'; }).forEach(function (it) {
      el('path', { d: heart(it.x, it.y, it.size), fill: 'none', stroke: cfg.color, 'stroke-width': Math.max(1.2, it.size * 0.07), 'stroke-linejoin': 'round' }, g);
    });

    var items = cfg.items.filter(function (it) { return it.type !== 'heart'; }).map(function (it) {
      var input = scope.querySelector('[name="properties[' + it.prop + ']"]');
      var grp = el('g', {}, g);
      var font = it.font === 'symbol' ? cfg.symbolFont : cfg.font;
      var common = { x: it.x, y: it.y, 'text-anchor': it.anchor || 'middle', 'font-family': font, 'font-size': it.size };
      if (it.type === 'zodiac' && cfg.symbolWeight) common['font-weight'] = cfg.symbolWeight;
      var hi = el('text', Object.assign({ fill: 'rgba(255,255,255,.55)', transform: 'translate(0,' + (it.size * 0.018) + ')' }, common), grp);
      var tx = el('text', Object.assign({ fill: cfg.color }, common), grp);
      var deco = null;
      if (it.type === 'zodiac' && it.stars) {
        deco = el('g', { fill: cfg.color }, grp);
        var s = it.size;
        el('path', { d: star(it.x, it.y - s * 1.02, s * 0.16) }, deco);
        el('path', { d: star(it.x - s * 0.48, it.y - s * 0.28, s * 0.075) }, deco);
        el('path', { d: star(it.x + s * 0.4, it.y - s * 0.48, s * 0.07) }, deco);
        el('path', { d: star(it.x + s * 0.5, it.y - s * 0.22, s * 0.055) }, deco);
      }
      return { it: it, input: input, grp: grp, nodes: [hi, tx], deco: deco };
    });

    function fit(o) {
      // Réduit la taille si le texte dépasse la largeur prévue
      var base = o.it.size * (o.scale || 1);
      o.nodes.forEach(function (n) { n.setAttribute('font-size', base); });
      var max = o.it.maxW; if (!max) return;
      try {
        var w = o.nodes[1].getComputedTextLength();
        if (w > max) {
          var fs = Math.max(base * 0.45, base * max / w);
          o.nodes.forEach(function (n) { n.setAttribute('font-size', fs); });
        }
      } catch (e) {}
    }

    // Choix des polices : un groupe pour le prénom, un groupe pour les infos
    var pren = items.filter(function (o) { return o.it.prop === 'Prénom'; })[0] || items[0];
    var infos = items.filter(function (o) { return o !== pren && o.it.type !== 'zodiac'; });
    var groupes = Array.prototype.slice.call(box.querySelectorAll('.soan-apercu__fonts')).map(function (fs) {
      var cible = fs.getAttribute('data-cible');
      return {
        radios: Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')),
        samples: fs.querySelectorAll('.soan-apercu__fontsample'),
        targets: cible === 'infos' ? infos : (pren ? [pren] : []),
        cible: cible
      };
    });
    var radios = [];
    groupes.forEach(function (gp) { radios = radios.concat(gp.radios); });
    function setFonts() {
      groupes.forEach(function (gp) {
        var r = gp.radios.filter(function (x) { return x.checked; })[0];
        if (!r) return;
        var sc = parseFloat(r.getAttribute('data-scale')) || 1;
        gp.targets.forEach(function (o) {
          o.scale = sc;
          o.nodes.forEach(function (n) {
            n.setAttribute('font-family', r.getAttribute('data-font'));
            n.setAttribute('font-weight', r.getAttribute('data-weight') || 400);
            n.setAttribute('font-style', r.getAttribute('data-style') || 'normal');
          });
        });
      });
    }
    function setSamples() {
      groupes.forEach(function (gp) {
        var src = gp.cible === 'infos'
          ? (infos.filter(function (o) { return o.it.prop === 'Date de naissance'; })[0] || infos[0])
          : pren;
        if (!src) return;
        var pv = (src.input && src.input.value.trim()) || src.it.sample;
        for (var i = 0; i < gp.samples.length; i++) {
          var sp = gp.samples[i];
          sp.textContent = pv; sp.style.fontSize = '';
          var room = sp.parentNode.clientWidth - 14, sw = sp.scrollWidth;
          if (room > 0 && sw > room) sp.style.fontSize = Math.max(11, 26 * room / sw) + 'px';
        }
      });
    }

    function render() {
      var any = false;
      setFonts();
      items.forEach(function (o) {
        var v = o.input ? o.input.value.trim() : '';
        if (v) any = true;
        var txt;
        if (o.it.type === 'zodiac') txt = signe(v || o.it.sample);
        else txt = v || o.it.sample;
        o.grp.style.opacity = v ? 1 : 0.4;
        o.nodes.forEach(function (n) { n.textContent = txt || ''; });
        if (o.deco) o.deco.style.display = txt ? '' : 'none';
        fit(o);
      });
      setSamples();
      box.classList.toggle('is-exemple', !any);
    }

    radios.forEach(function (r) { r.addEventListener('change', render); });
    items.forEach(function (o) {
      if (o.input) { o.input.addEventListener('input', render); o.input.addEventListener('change', render); }
    });
    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);
    if (document.fonts && document.fonts.load) {
      var loads = [document.fonts.load(cfg.items[0].size + 'px ' + cfg.font), document.fonts.load('40px ' + cfg.symbolFont)];
      radios.forEach(function (r) {
        loads.push(document.fonts.load((r.getAttribute('data-style') === 'italic' ? 'italic ' : '') + (r.getAttribute('data-weight') || 400) + ' 40px "' + r.getAttribute('data-font') + '"'));
      });
      Promise.all(loads).then(render, render);
    }
  }

  function init() {
    document.querySelectorAll('[data-soan-apercu]').forEach(function (box) {
      if (box.__soanApercu) return; box.__soanApercu = true;
      var cfg; try { cfg = JSON.parse(box.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
      // Place l'aperçu en tête du bloc de personnalisation, s'il existe
      var first = document.querySelector('[name="properties[' + cfg.items[0].prop + ']"]');
      var perso = first && first.closest('.soan-perso');
      if (perso) {
        var title = perso.querySelector('.soan-perso__title');
        if (title && title.nextSibling) perso.insertBefore(box, title.nextSibling); else perso.insertBefore(box, perso.firstChild);
      }
      box.hidden = false;
      build(box, cfg);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
